import { rechargeApiRequest, getInternalSession } from '../utils/request.js';

async function getCharge(session, id, options) {
  if (id === void 0 || id === "") {
    throw new Error("ID is required");
  }
  const { charge } = await rechargeApiRequest(
    "get",
    `/charges`,
    { id, query: { include: options?.include } },
    getInternalSession(session, "getCharge")
  );
  return charge;
}
function listCharges(session, query) {
  return rechargeApiRequest(
    "get",
    `/charges`,
    { query },
    getInternalSession(session, "listCharges")
  );
}
async function applyDiscountToCharge(session, id, discountCode) {
  if (id === void 0 || id === "") {
    throw new Error("ID is required");
  }
  const { charge } = await rechargeApiRequest(
    "post",
    `/charges/${id}/apply_discount`,
    {
      data: { discount_code: discountCode }
    },
    getInternalSession(session, "applyDiscountToCharge")
  );
  return charge;
}
async function removeDiscountsFromCharge(session, id) {
  if (id === void 0 || id === "") {
    throw new Error("ID is required");
  }
  const { charge } = await rechargeApiRequest(
    "post",
    `/charges/${id}/remove_discount`,
    {},
    getInternalSession(session, "removeDiscountsFromCharge")
  );
  return charge;
}
async function skipCharge(session, id, purchaseItemIds, query) {
  if (id === void 0 || id === "") {
    throw new Error("ID is required");
  }
  if (purchaseItemIds === void 0 || purchaseItemIds.length === 0) {
    throw new Error("Purchase item IDs are required");
  }
  const { charge } = await rechargeApiRequest(
    "post",
    `/charges/${id}/skip`,
    {
      query,
      data: {
        purchase_item_ids: purchaseItemIds.map((id2) => Number(id2))
      }
    },
    getInternalSession(session, "skipCharge")
  );
  return charge;
}
async function unskipCharge(session, id, purchaseItemIds, query) {
  if (id === void 0 || id === "") {
    throw new Error("ID is required");
  }
  if (purchaseItemIds === void 0 || purchaseItemIds.length === 0) {
    throw new Error("Purchase item IDs are required");
  }
  const { charge } = await rechargeApiRequest(
    "post",
    `/charges/${id}/unskip`,
    {
      query,
      data: {
        purchase_item_ids: purchaseItemIds.map((id2) => Number(id2))
      }
    },
    getInternalSession(session, "unskipCharge")
  );
  return charge;
}
async function processCharge(session, id) {
  if (id === void 0 || id === "") {
    throw new Error("ID is required");
  }
  const { charge } = await rechargeApiRequest(
    "post",
    `/charges/${id}/process`,
    {},
    getInternalSession(session, "processCharge")
  );
  return charge;
}

export { applyDiscountToCharge, getCharge, listCharges, processCharge, removeDiscountsFromCharge, skipCharge, unskipCharge };
//# sourceMappingURL=charge.js.map
